module.exports = __webpack_public_path__ + "img/playlist_blender_3.3e219948.png";